const getters = {
    routerList: state => state.permission.routerList,
    sidebarRouters: state => state.permission.sidebarRouters,
    token: state => state.user.token,
    roles: state => state.user.roles,
    loadMenus: state => state.user.loadMenus,
    visitedViews: state => state.tagsView.visitedViews,
    refreshToken: state => state.user.refreshToken,
    tokenstate: state => state.user.tokenstate,
    user: state => state.user.user,
    sidebar: state => state.app.sidebar,
    language: state => state.user.language,
    theme: state => state.user.theme,
    type: state => state.machine.type,
    machineList: state => state.machine.machineList,
}
export default getters